import { render, staticRenderFns } from "./BlogPostComponent.vue?vue&type=template&id=d9bc88d6&lang=pug&"
import script from "./BlogPostComponent.vue?vue&type=script&lang=js&"
export * from "./BlogPostComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports